import React, { useCallback, useEffect, useState } from 'react';
import { createAnnounceUserView, downloadAttachment, getAnnounceView } from './helpers/call-api';
import { notification } from 'antd';
import { getErrorMessage } from 'utils/index';
import _ from 'lodash';
import _500img from 'assets/502.png';
import Loading from 'components/shared/Loading/index';
import './styles/custom.scss';

const getAttachmentList = (announce = {}) => {
  const rawList = announce?.attachment_list || announce?.attachment || announce?.attachments || [];
  return (Array.isArray(rawList) ? rawList : []).filter(
    (item) => item?.announce_attachment_id || item?.attachment_name || item?.attachment_path,
  );
};

const getAttachmentName = (attachment = {}) => {
  return attachment?.attachment_name || attachment?.name || attachment?.file_name || 'Tệp đính kèm';
};

const AnnounceViewTable = ({ announce_id }) => {
  const [loading, setLoading] = useState(true);
  const [announceData, setAnnounceData] = useState({});

  const handleReadAnnounce = async (value) => {
    try {
      if (value.is_read === 0) {
        await createAnnounceUserView(value);
      }
    } catch (error) {
      getErrorMessage(error);
    }
  };
  const loadDetail = useCallback(() => {
    setLoading(true);
    if (announce_id)
      getAnnounceView(announce_id)
        .then((value) => {
          if (value) {
            setAnnounceData(value);
            handleReadAnnounce(value);
          }
        })
        .finally(() => {
          setLoading(false);
        });
  }, [announce_id]);
  useEffect(loadDetail, [loadDetail]);

  const handleDownloadFile = async (item) => {
    try {
      if (!item?.announce_attachment_id && item?.attachment_path) {
        window.open(item.attachment_path, '_blank');
        return;
      }
      await downloadAttachment(item.announce_attachment_id).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response?.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', getAttachmentName(item));
        document.body.appendChild(link);
        link.click();
      });
    } catch (error) {
      notification.error({ message: error.message || 'Lỗi tải tập tin.' });
    }
  };
  if (loading) {
    return <Loading />;
  } else if (announceData && !_.isEmpty(announceData)) {
    const attachmentList = getAttachmentList(announceData);

    return (
      <div className='bw_detail_notice'>
        <div className='bw_notice_detail_shell'>
          <div className='bw_notice_detail_header'>
            <span className='bw_notice_detail_label'>Thông báo nội bộ</span>
            <h2 className='bw_title_news_detail'>{announceData?.announce_title}</h2>
            <div className='bw_notice_detail_meta'>
              <strong>{announceData?.fullname}</strong>
              <span>vào {announceData?.created_date}</span>
            </div>
          </div>

          <div className='bw_main_content_news custom-editor-text'>
            <div dangerouslySetInnerHTML={{ __html: announceData?.announce_content }} />
          </div>

          <div className='bw_file_notice bw_notice_attachment_section'>
            <div className='bw_notice_attachment_header'>
              <div>
                <h3>Tệp đính kèm</h3>
                <p>{attachmentList.length ? `${attachmentList.length} tệp có thể tải xuống` : 'Thông báo này chưa có tệp đính kèm'}</p>
              </div>
            </div>
            {attachmentList.length ? (
              <div className='bw_notice_attachment_list'>
                {attachmentList.map((attachment, idx) => {
                  return (
                    <button type='button' key={idx} onClick={() => handleDownloadFile(attachment)}>
                      <span className='fi fi-rr-file-invoice' />
                      <span>{getAttachmentName(attachment)}</span>
                    </button>
                  );
                })}
              </div>
            ) : (
              <span className='bw_notice_attachment_empty'>Không có tệp đính kèm</span>
            )}
          </div>
        </div>
      </div>
    );
  } else
    return (
      <div className='bw_detail_notice'>
        <div className='bw_text_center'>
          <img src={_500img} alt={2} style={{ width: '90%' }} />
          <h2>Bạn không có quyền xem thông báo này!</h2>
        </div>
      </div>
    );
};

export default AnnounceViewTable;
